<template>
	<div>
		<v-layout wrap>
			<v-flex xs12 mt-5 class="tablePoll">
				<app-table
					title="Estudios"
					:name="name"
					:filter-columns="false"
					:rows="rows"
					:columns="computedColumns"
					:main-list="false"
					class="is-not-selectable"
					@on-search-event="$emit('on-search', $event)">
					<template slot="rows" slot-scope="{ row }">
						<td v-show="showRow(computedColumns, 1)" class="columna is-not-selectable border-top">{{
							row.tool === 'JEV' ? row.diagnostic.name : row.poll.name
						}}</td>
						<td v-show="showRow(computedColumns, 2)">{{row.diagnosticStartDate || null }}</td>
						<td v-show="showRow(computedColumns, 3)">{{row.diagnosticEndDate || null }}</td>
						<td v-show="showRow(computedColumns, 4)">
							<app-tooltip-button
							:text="changeText(row.flagDates)"
							:disabled="row.flagDates"
							:img="`${$imageUrl}/surveys.svg`"
							size="18"
							@click-icon="$emit('on-click', row)"
							/>
						</td>
					</template>
				</app-table>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>

function changeText(flag) {
	if (flag) {
		return 'Encuesta fuera de rango';
	}
	return 'Encuesta';
}

function computedColumns() {
	const self = this;
	return this.columns.map((c) => {
		const col = c;
		col.visible = col.value === 'actions' ? !self.noActions : col.visible;
		if (col.value === 'points') {
			col.name = !self.noActions ? 'Puntos por Ganar' : 'Puntos Ganados';
		}
		return col;
	});
}

export default {
	name: 'poll-table',
	methods: {
		changeText,
	},
	computed: {
		computedColumns,
	},
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		name: String,
		noActions: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.columna {
	width: 350px;
}
.tablePoll{
	@media (max-width: 768px) {
		display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/polls/poll-table.vue